import { serializeResultDuration } from '../utils/result-duration';
import API_BASE_URL from '../config/api';
import FloatingRacePanel from './floating-race-panel';
import React, { Component } from 'react';

import {
  BootstrapTable,
  TableHeaderColumn
} from 'react-bootstrap-table';

import {
  bindActionCreators
} from 'redux';

import {
  connect
} from 'react-redux';

import {
  editRegisterTime,
  incTime,
  decTime
} from '../actions/index';

import '../css/App.css';
import '../css/station-mode.css';

import {
  ButtonGroup,
  Button,
  Grid,
  Row,
  Col,
  PageHeader,
  Alert
} from 'react-bootstrap';

import {
  Parcial1Field,
  Parcial2Field,
  Parcial3Field,
  Pedestrismo,
  PedestrismoBackup,
  RuralBike,
  CombinadaSprint,
  CombinadaSimple,
  genderList
} from '../constants/enums';

import axios from 'axios';

import SMSButton from './sms-button';

import {
  utilsFilterList,
  utilsGeneralFilter,
  utilsFormatTime,
  utilsGenderFilter,
  utilsCategoryFilter
} from '../utils/utilities';


export class ResultsTable extends Component {

  constructor(props) {

    super(props);

    this.handleClick =
      this.handleClick.bind(this);

    this.onAfterSaveCell =
      this.onAfterSaveCell.bind(this);

    this.actionIncTimeButton =
      this.actionIncTimeButton.bind(this);

    this.actionDecTimeButton =
      this.actionDecTimeButton.bind(this);

    this.buttonFormatter =
      this.buttonFormatter.bind(this);

    this.enumFormatter =
      this.enumFormatter.bind(this);


    this.state = {

      genderList,
      uploading: false,
      uploadStatus: '',
      uploadLog: [],

      sendButton:
        'Resultados',

      cellEditProp: {

        mode:
          'dbclick',

        blurToSave:
          true,

        afterSaveCell:
          this.onAfterSaveCell
      }
    };
  }


  /*
   * =======================================================
   * LISTAS
   * =======================================================
   */

  filterList() {

    const participantList =
      Array.isArray(
        this.props.participantList
      )
        ? this.props.participantList
        : [];


    return (
      utilsFilterList(
        participantList
      )
      ||
      []
    );
  }


  /*
   * Participantes que deben aparecer
   * en resultados.
   *
   * Incluye:
   *
   * - llegada
   * - DNS
   * - DNF
   * - DSQ
   */
  displayList() {

    const participantList =
      Array.isArray(
        this.props.participantList
      )
        ? this.props.participantList
        : [];


    return participantList.filter(
      (participant) => {

        return (

          Number(
            participant.registeredTime1 || 0
          ) > 0

          ||

          Number(
            participant.dns || 0
          ) === 1

          ||

          Number(
            participant.dnf || 0
          ) === 1

          ||

          Number(
            participant.disqualified || 0
          ) === 1
        );
      }
    );
  }


  /*
   * =======================================================
   * ESTADOS
   * =======================================================
   */

  getParticipantStatus(
    participant
  ) {

    if (
      Number(
        participant.dns || 0
      ) === 1
    ) {

      return 'DNS';
    }


    if (
      Number(
        participant.dnf || 0
      ) === 1
    ) {

      return 'DNF';
    }


    if (
      Number(
        participant.disqualified || 0
      ) === 1
    ) {

      return 'DSQ';
    }


    return '';
  }


  hasSpecialStatus(
    participant
  ) {

    return (
      this.getParticipantStatus(
        participant
      ) !== ''
    );
  }


  /*
   * =======================================================
   * DISTANCIAS PEDESTRISMO
   * =======================================================
   */

  getConfiguredDistances() {

    const distances = [

      {
        id: 1,
        type:
          this.props.distance1Type,
        value:
          this.props.distance1Value
      },

      {
        id: 2,
        type:
          this.props.distance2Type,
        value:
          this.props.distance2Value
      },

      {
        id: 3,
        type:
          this.props.distance3Type,
        value:
          this.props.distance3Value
      }
    ];


    return distances.filter(
      (distance) => {

        const typeIsValid =

          distance.type !==
            undefined

          &&

          distance.type !==
            null

          &&

          String(
            distance.type
          ).trim() !== '';


        const numericValue =
          Number(
            distance.value
          );


        const valueIsValid =

          !Number.isNaN(
            numericValue
          )

          &&

          numericValue > 0;


        return (
          typeIsValid &&
          valueIsValid
        );
      }
    );
  }


  getDistanceValue(
    distanceType
  ) {

    const configuredDistance =
      this.getConfiguredDistances()
        .find(
          (distance) => {

            return (

              String(
                distance.type
              ).trim()

              ===

              String(
                distanceType
              ).trim()
            );
          }
        );


    if (
      !configuredDistance
    ) {

      return 0;
    }


    const value =
      Number(
        configuredDistance.value
      );


    return Number.isNaN(
      value
    )
      ? 0
      : value;
  }


  /*
   * =======================================================
   * POSICIONES
   * =======================================================
   */

  getGeneralPosition(
    participant,
    distanceType = null
  ) {

    if (
      this.hasSpecialStatus(
        participant
      )
    ) {

      return '';
    }


    const rankingList =
      this.filterList()
        .filter(
          (item) =>
            !this.hasSpecialStatus(
              item
            )
        );


    const filteredList =
      utilsGeneralFilter(
        distanceType,
        rankingList
      )
      ||
      [];


    const position =
      filteredList.indexOf(
        participant
      );


    return position >= 0
      ? position + 1
      : '';
  }


  getGenderPosition(
    participant,
    distanceType = null
  ) {

    if (
      this.hasSpecialStatus(
        participant
      )
    ) {

      return '';
    }


    const rankingList =
      this.filterList()
        .filter(
          (item) =>
            !this.hasSpecialStatus(
              item
            )
        );


    const filteredList =
      utilsGenderFilter(
        distanceType,
        rankingList,
        participant.gender
      )
      ||
      [];


    const position =
      filteredList.indexOf(
        participant
      );


    return position >= 0
      ? position + 1
      : '';
  }


  /*
   * Para Pedestrismo conserva
   * utilsCategoryFilter.
   *
   * Para MTB / Rural Bike /
   * Duatlón / Triatlón ordena
   * la categoría por TIEMPO NETO.
   */
  getCategoryPosition(
    participant
  ) {

    if (
      this.hasSpecialStatus(
        participant
      )
    ) {

      return '';
    }


    const participantCatCod =
      String(
        participant.catCod || ''
      ).trim();


    if (
      participantCatCod === ''
    ) {

      return '';
    }


    const rankingList =
      this.filterList()
        .filter(
          (item) => {

            return (

              !this.hasSpecialStatus(
                item
              )

              &&

              Number(
                item.registeredTime1 || 0
              ) > 0

              &&

              String(
                item.catCod || ''
              ).trim() ===
                participantCatCod
            );
          }
        );


    /*
     * PEDESTRISMO
     */
    if (
      this.props.competition ===
        Pedestrismo

      ||

      this.props.competition ===
        PedestrismoBackup
    ) {

      const filteredList =
        utilsCategoryFilter(
          rankingList,
          participant.catCod
        )
        ||
        [];


      const position =
        filteredList.indexOf(
          participant
        );


      return position >= 0
        ? position + 1
        : '';
    }


    /*
     * MTB / RURAL BIKE /
     * DUATLON / TRIATLON
     */
    const orderedList =
      rankingList
        .slice()
        .sort(
          (
            participant1,
            participant2
          ) => {

            return (

              this.getNetRegisteredTime(
                participant1
              )

              -

              this.getNetRegisteredTime(
                participant2
              )
            );
          }
        );


    const position =
      orderedList.findIndex(
        (item) => {

          return (

            String(
              item.id
            )

            ===

            String(
              participant.id
            )
          );
        }
      );


    return position >= 0
      ? position + 1
      : '';
  }


  /*
   * =======================================================
   * OFFSETS POR CATEGORIA
   * =======================================================
   */

  getCategoryStartOffset(
    participant
  ) {

    if (
      !participant
    ) {

      return 0;
    }


    const catCod =
      String(
        participant.catCod || ''
      ).trim();


    if (
      catCod === ''
    ) {

      return 0;
    }


    const categoryStartOffsets =
      Array.isArray(
        this.props.categoryStartOffsets
      )
        ? this.props.categoryStartOffsets
        : [];


    const config =
      categoryStartOffsets.find(
        (item) => {

          return (

            String(
              item.catCod || ''
            ).trim()

            ===

            catCod
          );
        }
      );


    if (
      !config
    ) {

      return 0;
    }


    const offset =
      Number(
        config.offset || 0
      );


    return Number.isNaN(
      offset
    )
      ? 0
      : offset;
  }


  /*
   * Tiempo desde T0 general
   * hasta el momento real de llegada.
   *
   * NO descuenta offset.
   */
  getArrivalRegisteredTime(
    participant
  ) {

    if (
      !participant
    ) {

      return 0;
    }


    const registeredTime =
      Number(
        participant.registeredTime1 || 0
      );


    const startedAt =
      Number(
        this.props.startedAt || 0
      );


    if (
      registeredTime <= 0
      ||
      startedAt <= 0
    ) {

      return 0;
    }


    return Math.max(
      0,

      registeredTime -
        startedAt
    );
  }


  /*
   * Tiempo deportivo real.
   *
   * Pedestrismo:
   *
   * registeredTime1 - startedAt
   *
   * MTB / Duatlón / Triatlón:
   *
   * registeredTime1
   * - startedAt
   * - offset categoría
   */
  getNetRegisteredTime(
    participant
  ) {

    if (
      !participant
    ) {

      return 0;
    }


    const registeredTime =
      Number(
        participant.registeredTime1 || 0
      );


    const startedAt =
      Number(
        this.props.startedAt || 0
      );


    if (
      registeredTime <= 0
      ||
      startedAt <= 0
    ) {

      return 0;
    }


    const elapsed =
      registeredTime -
        startedAt;


    /*
     * PEDESTRISMO
     */
    if (
      this.props.competition ===
        Pedestrismo

      ||

      this.props.competition ===
        PedestrismoBackup
    ) {

      return Math.max(
        0,
        elapsed
      );
    }


    const categoryOffsetMinutes =
      this.getCategoryStartOffset(
        participant
      );


    const categoryOffsetMs =

      categoryOffsetMinutes

      *

      60

      *

      1000;


    return Math.max(
      0,

      elapsed -
        categoryOffsetMs
    );
  }


  /*
   * =======================================================
   * INFORMACION DE LARGADA POR CATEGORIA
   * =======================================================
   *
   * Devuelve:
   *
   * {
   *   timeIndex: 5,
   *   timeLabel: 'T5',
   *   offset: 5,
   *   label: 'T5 (+05:00)'
   * }
   */
  getCategoryStartInfo(
    participant
  ) {

    if (
      !participant
    ) {

      return {

        timeIndex:
          0,

        timeLabel:
          'T0',

        offset:
          0,

        label:
          'T0 (00:00)'
      };
    }


    const catCod =
      String(
        participant.catCod || ''
      ).trim();


    const categoryStartOffsets =
      Array.isArray(
        this.props.categoryStartOffsets
      )
        ? this.props.categoryStartOffsets
        : [];


    const uniqueOffsets =
      Array.from(
        new Set(
          categoryStartOffsets.map(
            (item) =>
              Number(
                item.offset || 0
              )
          )
        )
      )
        .sort(
          (a, b) =>
            a - b
        );


    if (
      uniqueOffsets.length === 0
    ) {

      return {

        timeIndex:
          0,

        timeLabel:
          'T0',

        offset:
          0,

        label:
          'T0 (00:00)'
      };
    }


    const config =
      categoryStartOffsets.find(
        (item) => {

          return (

            String(
              item.catCod || ''
            ).trim()

            ===

            catCod
          );
        }
      );


    const offset =
      config
        ? Number(
          config.offset || 0
        )
        : 0;


    let timeIndex =
      uniqueOffsets.indexOf(
        offset
      );


    if (
      timeIndex < 0
    ) {

      timeIndex = 0;
    }


    const timeLabel =
      'T' +
      timeIndex;


    return {

      timeIndex,

      timeLabel,

      offset,

      label:

        timeLabel +

        ' (' +

        (
          offset > 0
            ? '+'
            : ''
        ) +

        this.formatStartOffset(
          offset
        ) +

        ')'
    };
  }


  /*
   * Formatea minutos de offset:
   *
   * 0 -> 00:00
   * 1 -> 01:00
   * 5 -> 05:00
   */
  formatStartOffset(
    offsetMinutes
  ) {

    const safeMinutes =
      Math.max(
        0,
        Number(
          offsetMinutes || 0
        )
      );


    const totalSeconds =
      Math.round(
        safeMinutes *
        60
      );


    const hours =
      Math.floor(
        totalSeconds /
        3600
      );


    const minutes =
      Math.floor(
        (
          totalSeconds %
          3600
        ) /
        60
      );


    const seconds =
      totalSeconds %
      60;


    if (
      hours > 0
    ) {

      return (

        String(
          hours
        ).padStart(
          2,
          '0'
        )

        +

        ':'

        +

        String(
          minutes
        ).padStart(
          2,
          '0'
        )

        +

        ':'

        +

        String(
          seconds
        ).padStart(
          2,
          '0'
        )
      );
    }


    return (

      String(
        minutes
      ).padStart(
        2,
        '0'
      )

      +

      ':'

      +

      String(
        seconds
      ).padStart(
        2,
        '0'
      )
    );
  }


  /*
   * =======================================================
   * FORMATO PEDESTRISMO
   * =======================================================
   */

  formattedList(
    distanceType
  ) {

    const resultList =
      this.displayList()
        .slice(
          0
        );


    const normalizedDistanceType =
      String(
        distanceType
      ).trim();


    const filteredList =
      resultList

        .filter(
          (participant) => {

            return (

              String(
                participant.distance
              ).trim()

              ===

              normalizedDistanceType
            );
          }
        )

        .sort(
          (
            participant1,
            participant2
          ) => {

            const status1 =
              this.getParticipantStatus(
                participant1
              );


            const status2 =
              this.getParticipantStatus(
                participant2
              );


            const hasStatus1 =
              status1 !== '';


            const hasStatus2 =
              status2 !== '';


            if (
              hasStatus1 !==
              hasStatus2
            ) {

              return hasStatus1
                ? 1
                : -1;
            }


            if (
              !hasStatus1 &&
              !hasStatus2
            ) {

              return (

                Number(
                  participant1.registeredTime1 || 0
                )

                -

                Number(
                  participant2.registeredTime1 || 0
                )
              );
            }


            const statusOrder = {

              DNF:
                1,

              DSQ:
                2,

              DNS:
                3
            };


            const statusDifference =

              (
                statusOrder[
                  status1
                ]
                ||
                99
              )

              -

              (
                statusOrder[
                  status2
                ]
                ||
                99
              );


            if (
              statusDifference !==
              0
            ) {

              return statusDifference;
            }


            return (

              Number(
                participant1.number || 0
              )

              -

              Number(
                participant2.number || 0
              )
            );
          }
        );


    const distanceValue =
      this.getDistanceValue(
        distanceType
      );


    return filteredList.map(
      (participant) => {

        const specialStatus =
          this.getParticipantStatus(
            participant
          );


        participant.status =
          specialStatus;


        if (
          specialStatus
        ) {

          participant.formattedTime1 =
            '';

          participant.rhythm =
            '';

          participant.posCat =
            '';

          participant.posGender =
            '';

          participant.posGral =
            '';


          return participant;
        }


        const milliDiff =
          Math.floor(

            participant.registeredTime1

            -

            this.props.startedAt
          );


        // Recompute cached durations when the race reference (t0) changes.
        participant.totalTime = milliDiff;
        participant.netTime = milliDiff;
        participant.formattedTime1 =
          utilsFormatTime(
            true,
            milliDiff
          );


        if (
          distanceValue > 0
        ) {

          participant.rhythm =
            utilsFormatTime(

              true,

              (
                milliDiff /
                distanceValue
              )

              *

              1000
            );

        } else {

          participant.rhythm =
            '';
        }


        participant.posCat =
          this.getCategoryPosition(
            participant
          );


        participant.posGender =
          this.getGenderPosition(
            participant,
            distanceType
          );


        participant.posGral =
          this.getGeneralPosition(
            participant,
            distanceType
          );


        return participant;
      }
    );
  }


  /*
   * =======================================================
   * FORMATO RURAL BIKE / MTB
   * =======================================================
   */

  ruralBikeFormattedList() {

    const resultList =
      this.displayList()
        .slice(0);


    const formattedList =
      resultList.map(
        (participant) => {

          const specialStatus =
            this.getParticipantStatus(
              participant
            );


          const startInfo =
            this.getCategoryStartInfo(
              participant
            );


          participant.status =
            specialStatus;


          participant.startOffset =
            startInfo.offset;


          participant.startTimeIndex =
            startInfo.timeIndex;


          participant.startLabel =
            startInfo.label;


          /*
           * DNS / DNF / DSQ
           */
          if (
            specialStatus
          ) {

            participant.arrivalTime =
              0;

            participant.netTime =
              0;

            participant.formattedArrivalTime =
              '';

            participant.formattedTime1 =
              '';

            participant.totalTime =
              0;

            participant.posCat =
              '';


            return participant;
          }


          const arrivalTime =
            Math.floor(
              this.getArrivalRegisteredTime(
                participant
              )
            );


          const netTime =
            Math.floor(
              this.getNetRegisteredTime(
                participant
              )
            );


          participant.arrivalTime =
            arrivalTime;


          participant.netTime =
            netTime;


          participant.formattedArrivalTime =
            utilsFormatTime(
              true,
              arrivalTime
            );


          participant.formattedTime1 =
            utilsFormatTime(
              true,
              netTime
            );


          participant.totalTime =
            netTime;


          participant.posCat =
            this.getCategoryPosition(
              participant
            );


          return participant;
        }
      );


    const statusOrder = {

      DNF:
        1,

      DSQ:
        2,

      DNS:
        3
    };


    return formattedList.sort(
      (
        participant1,
        participant2
      ) => {

        const status1 =
          this.getParticipantStatus(
            participant1
          );


        const status2 =
          this.getParticipantStatus(
            participant2
          );


        const hasStatus1 =
          status1 !== '';


        const hasStatus2 =
          status2 !== '';


        if (
          hasStatus1 !==
          hasStatus2
        ) {

          return hasStatus1
            ? 1
            : -1;
        }


        if (
          !hasStatus1 &&
          !hasStatus2
        ) {

          return (

            Number(
              participant1.netTime || 0
            )

            -

            Number(
              participant2.netTime || 0
            )
          );
        }


        const statusDifference =

          (
            statusOrder[
              status1
            ] || 99
          )

          -

          (
            statusOrder[
              status2
            ] || 99
          );


        if (
          statusDifference !== 0
        ) {

          return statusDifference;
        }


        return (

          Number(
            participant1.number || 0
          )

          -

          Number(
            participant2.number || 0
          )
        );
      }
    );
  }

    /*
   * =======================================================
   * FORMATO COMBINADA SIMPLE
   * =======================================================
   */

  combinadaFormattedList() {

    const resultList =
      this.displayList()
        .slice(0);


    const formattedList =
      resultList.map(
        (participant) => {

          const specialStatus =
            this.getParticipantStatus(
              participant
            );


          const startInfo =
            this.getCategoryStartInfo(
              participant
            );


          participant.status =
            specialStatus;


          participant.startOffset =
            startInfo.offset;


          participant.startTimeIndex =
            startInfo.timeIndex;


          participant.startLabel =
            startInfo.label;


          if (
            specialStatus
          ) {

            participant.arrivalTime =
              0;

            participant.netTime =
              0;

            participant.formattedArrivalTime =
              '';

            participant.formattedTime1 =
              '';

            participant.totalTime =
              0;

            participant.formattedTotalTime =
              '';

            participant.posCat =
              '';


            return participant;
          }


          const arrivalTime =
            Math.floor(
              this.getArrivalRegisteredTime(
                participant
              )
            );


          const netTime =
            Math.floor(
              this.getNetRegisteredTime(
                participant
              )
            );


          participant.arrivalTime =
            arrivalTime;


          participant.netTime =
            netTime;


          participant.formattedArrivalTime =
            utilsFormatTime(
              true,
              arrivalTime
            );


          participant.formattedTime1 =
            utilsFormatTime(
              true,
              netTime
            );


          participant.posCat =
            this.getCategoryPosition(
              participant
            );


          participant.totalTime =
            netTime;


          participant.formattedTotalTime =
            utilsFormatTime(
              true,
              netTime
            );


          return participant;
        }
      );


    return formattedList.sort(
      (
        participant1,
        participant2
      ) => {

        const status1 =
          this.getParticipantStatus(
            participant1
          );


        const status2 =
          this.getParticipantStatus(
            participant2
          );


        const hasStatus1 =
          status1 !== '';


        const hasStatus2 =
          status2 !== '';


        if (
          hasStatus1 !==
          hasStatus2
        ) {

          return hasStatus1
            ? 1
            : -1;
        }


        if (
          !hasStatus1 &&
          !hasStatus2
        ) {

          return (

            Number(
              participant1.netTime || 0
            )

            -

            Number(
              participant2.netTime || 0
            )
          );
        }


        const statusOrder = {

          DNF:
            1,

          DSQ:
            2,

          DNS:
            3
        };


        const statusDifference =

          (
            statusOrder[
              status1
            ] || 99
          )

          -

          (
            statusOrder[
              status2
            ] || 99
          );


        if (
          statusDifference !== 0
        ) {

          return statusDifference;
        }


        return (

          Number(
            participant1.number || 0
          )

          -

          Number(
            participant2.number || 0
          )
        );
      }
    );
  }


  /*
   * =======================================================
   * FORMATO COMBINADA SPRINT
   * =======================================================
   */

  combinadaSprintFormattedList() {

    const resultList =
      this.displayList()
        .slice(0);


    const formattedList =
      resultList.map(
        (participant) => {

          const specialStatus =
            this.getParticipantStatus(
              participant
            );


          const startInfo =
            this.getCategoryStartInfo(
              participant
            );


          participant.status =
            specialStatus;


          participant.startOffset =
            startInfo.offset;


          participant.startTimeIndex =
            startInfo.timeIndex;


          participant.startLabel =
            startInfo.label;


          if (
            specialStatus
          ) {

            participant.arrivalTime =
              0;

            participant.netTime =
              0;

            participant.formattedArrivalTime =
              '';

            participant.formattedTime1 =
              '';

            participant.formattedTime2 =
              '';

            participant.formattedTotalTime =
              '';

            participant.totalTime =
              0;


            return participant;
          }


          let total;

          let partial1;

          let partial2;


          const arrivalTime =
            Math.floor(
              this.getArrivalRegisteredTime(
                participant
              )
            );


          participant.arrivalTime =
            arrivalTime;


          participant.formattedArrivalTime =
            utilsFormatTime(
              true,
              arrivalTime
            );


          /*
           * Primer parcial NETO:
           *
           * llegada P1
           * -
           * offset categoría.
           */
          partial1 =
            Math.floor(
              this.getNetRegisteredTime(
                participant
              )
            );


          participant.formattedTime1 =
            utilsFormatTime(
              true,
              partial1
            );


          participant.totalTime =
            partial1;


          /*
           * Los parciales posteriores son
           * diferencias entre timestamps.
           *
           * No se descuenta nuevamente
           * el offset.
           */
          if (
            participant.registeredTime2 > 0
          ) {

            partial2 =
              Math.floor(

                participant.registeredTime2

                -

                participant.registeredTime1
              );


            participant.formattedTime2 =
              utilsFormatTime(
                true,
                partial2
              );


            participant.totalTime +=
              partial2;
          }


          total =
            Math.floor(
              participant.totalTime
            );


          participant.netTime =
            total;


          participant.formattedTotalTime =
            utilsFormatTime(
              true,
              total
            );


          return participant;
        }
      );


    return formattedList.sort(
      (
        participant1,
        participant2
      ) => {

        const status1 =
          this.getParticipantStatus(
            participant1
          );


        const status2 =
          this.getParticipantStatus(
            participant2
          );


        const hasStatus1 =
          status1 !== '';


        const hasStatus2 =
          status2 !== '';


        if (
          hasStatus1 !==
          hasStatus2
        ) {

          return hasStatus1
            ? 1
            : -1;
        }


        if (
          !hasStatus1 &&
          !hasStatus2
        ) {

          return (

            Number(
              participant1.totalTime || 0
            )

            -

            Number(
              participant2.totalTime || 0
            )
          );
        }


        const statusOrder = {

          DNF:
            1,

          DSQ:
            2,

          DNS:
            3
        };


        const statusDifference =

          (
            statusOrder[
              status1
            ] || 99
          )

          -

          (
            statusOrder[
              status2
            ] || 99
          );


        if (
          statusDifference !== 0
        ) {

          return statusDifference;
        }


        return (

          Number(
            participant1.number || 0
          )

          -

          Number(
            participant2.number || 0
          )
        );
      }
    );
  }


  /*
   * =======================================================
   * FORMATTERS
   * =======================================================
   */

  enumFormatter(
    cell,
    row,
    enumObject
  ) {

    return enumObject
      ? enumObject[
        cell
      ]
      : cell;
  }


  componentDidMount() {

    console.log(
      'componentDidMount',
      axios
    );
  }


  buttonFormatter(
    cell,
    row
  ) {

    if (
      this.hasSpecialStatus(
        row
      )
    ) {

      return null;
    }


    /*
     * PEDESTRISMO
     */
    if (
      row.competition ===
        Pedestrismo

      ||

      row.competition ===
        PedestrismoBackup
    ) {

      const formattedTime =
        row.formattedTime1 || '';


      const rhythm =
        row.rhythm || '';


      const visibleTime =
        formattedTime.length > 2

          ? formattedTime.substr(
            0,
            formattedTime.length - 2
          )

          : formattedTime;


      const posGral =

        ' Clasificaste '

        +

        row.posGral

        +

        ' en '

        +

        row.distance

        +

        'K.';


      const message =

        row.first

        +

        '!'

        +

        posGral

        +

        ' Tiempo: '

        +

        visibleTime

        +

        ', Ritmo: '

        +

        rhythm

        +

        ' (min/km). ';


      return (

        <SMSButton
          hide={
            !(
              row.phone &&
              row.phone.length === 10
            )
          }
          phone={
            row.phone
          }
          message={
            message
          }
          label="SMS"
        />
      );
    }


    /*
     * RURAL BIKE
     */
    if (
      row.competition ===
        RuralBike
    ) {

      const formattedTime =
        row.formattedTime1 || '';


      const visibleTime =
        formattedTime.length > 2

          ? formattedTime.substr(
            0,
            formattedTime.length - 2
          )

          : formattedTime;


      const position =

        'Clasificaste '

        +

        row.posCat

        +

        ' en '

        +

        row.catName

        +

        '. ';


      const message =

        row.first

        +

        '! '

        +

        position

        +

        'Tiempo Neto: '

        +

        visibleTime;


      return (

        <SMSButton
          hide={
            !(
              row.phone &&
              row.phone.length === 10
            )
          }
          phone={
            row.phone
          }
          message={
            message
          }
          label="SMS"
        />
      );
    }


    return null;
  }


  /*
   * =======================================================
   * + / - MINUTO
   * =======================================================
   */

  updateTime(
    row,
    action
  ) {

    const index =
      this.getPositionOf(
        row.number
      );


    const originalTime =
      row.registeredTime1;


    if (
      index < 0
    ) {

      return;
    }


    if (
      action === '+'
    ) {

      setTimeout(
        () => {

          this.props.incTime(
            originalTime,
            index,
            this.props.competition
          );

        },
        1
      );

    } else {

      setTimeout(
        () => {

          this.props.decTime(
            originalTime,
            index,
            this.props.competition
          );

        },
        1
      );
    }
  }


  actionIncTimeButton(
    cell,
    row
  ) {

    return (

      <Button
        onClick={
          () =>
            this.updateTime(
              row,
              '+'
            )
        }
      >
        +
      </Button>
    );
  }


  actionDecTimeButton(
    cell,
    row
  ) {

    return (

      <Button
        onClick={
          () =>
            this.updateTime(
              row,
              '-'
            )
        }
      >
        -
      </Button>
    );
  }


  /*
   * =======================================================
   * SUBIR RESULTADOS
   * =======================================================
   */

async handleClick(eventID, distanceID) {
  if (this.uploadInProgress || this.copyInProgress) return;
  this.uploadInProgress = true;
  const entry = {
    id: Date.now(),
    startedAt: new Date().toLocaleTimeString('es-AR'),
    eventID,
    distance: this.props.competition === Pedestrismo || this.props.competition === PedestrismoBackup
      ? distanceID + 'K' : 'General',
    message: 'Subiendo resultados…',
    pending: true
  };
  this.setState(state => ({
    uploading: true,
    uploadStatus: entry.message,
    uploadLog: [entry].concat(state.uploadLog).slice(0, 100)
  }));
  let message;
  try {
    message = await this.uploadResults(eventID, distanceID);
    message = message || 'No se pudo completar la subida.';
  } catch (error) {
    message = 'Error al subir resultados: ' + error.message;
  } finally {
    this.uploadInProgress = false;
    this.setState(state => ({
      uploading: false,
      uploadStatus: message,
      uploadLog: state.uploadLog.map(item => item.id === entry.id
        ? { ...item, pending: false, message, finishedAt: new Date().toLocaleTimeString('es-AR') }
        : item)
    }));
  }
}

  async uploadResults(
    eventID,
    distanceID
  ) {

    console.log(
      'Distancia seleccionada:',
      distanceID
    );


    let savedCount = 0;
    let failedCount = 0;
    let warnings = '';
    try {

      let data =
        [];


      switch (
        this.props.competition
      ) {

        case Pedestrismo:

        case PedestrismoBackup:

          data =
            this
              .formattedList(
                distanceID
              )
              .filter(
                (participant) => {

                  return (

                    !this.hasSpecialStatus(
                      participant
                    )

                    &&

                    Number(
                      participant.registeredTime1 ||
                      0
                    ) > 0
                  );
                }
              );

          break;


        case RuralBike:

          data =
            this
              .ruralBikeFormattedList()
              .filter(
                (participant) => {

                  return (

                    !this.hasSpecialStatus(
                      participant
                    )

                    &&

                    Number(
                      participant.registeredTime1 ||
                      0
                    ) > 0
                  );
                }
              );

          break;


        case CombinadaSprint:

          data =
            this
              .combinadaSprintFormattedList()
              .filter(
                (participant) => {

                  return (

                    !this.hasSpecialStatus(
                      participant
                    )

                    &&

                    Number(
                      participant.registeredTime1 ||
                      0
                    ) > 0
                  );
                }
              );

          break;


        default:

          data =
            this
              .combinadaFormattedList()
              .filter(
                (participant) => {

                  return (

                    !this.hasSpecialStatus(
                      participant
                    )

                    &&

                    Number(
                      participant.registeredTime1 ||
                      0
                    ) > 0
                  );
                }
              );

          break;
      }


      if (
        !Array.isArray(
          data
        )

        ||

        data.length === 0
      ) {

        console.warn(
          '⚠️ No hay datos para guardar.'
        );


        return 'No hay resultados para subir en esta distancia.';
      }


      console.log(

        '🚀 Guardando resultados ' +

        '(' +

        data.length +

        ' registros)'
      );


      const formatToApiDate =
        (
          timeString
        ) => {

          if (
            !timeString
          ) {

            return null;
          }


          const parts =
            timeString
              .split(':')
              .map(
                Number
              );


          if (
            parts.length < 3

            ||

            parts.some(
              (part) =>
                Number.isNaN(
                  part
                )
            )
          ) {

            return null;
          }


          const hh =
            parts[
              0
            ];


          const mm =
            parts[
              1
            ];


          const ss =
            parts[
              2
            ];


          const date =
            new Date();


          date.setUTCHours(
            hh - 3,
            mm,
            ss,
            0
          );


          date.setHours(
            date.getHours() +
            3
          );


          const iso =
            date.toISOString();


          return (

            iso.substring(
              0,
              10
            )

            +

            ' '

            +

            iso.substring(
              11,
              19
            )
          );
        };


      /*
       * ===================================================
       * COMBINADA SPRINT
       * ===================================================
       */
      if (
        this.props.competition ===
          CombinadaSprint
      ) {

        const batchSize =
          10;


        for (
          let index = 0;

          index < data.length;

          index += batchSize
        ) {

          const batch =
            data.slice(
              index,
              index +
                batchSize
            );


          await Promise.all(
            batch.map(
              async (participant) => {

                try {

                  const payload = {

                    partial1:
                      formatToApiDate(
                        participant.formattedTime1
                      ),

                    partial2:
                      formatToApiDate(
                        participant.formattedTime2
                      )
                  };


                  const response =
                    await axios.post(

                      (API_BASE_URL + '/user/')

                      +

                      participant.id

                      +

                      '/distance/'

                      +

                      participant.distanceID

                      +

                      '/save-partial-results',

                      payload
                    );


                  if (
                    response.status ===
                    200
                  ) {
                  savedCount += 1;

                    console.log(

                      `✅ Parciales de ${participant.fullname} ` +

                      `(${participant.number}) guardados correctamente`
                    );

                  } else {

                    failedCount += 1;
                  console.warn(

                      `⚠️ ${participant.fullname} respondió ` +

                      response.status
                    );
                  }

                } catch (
                  error
                ) {
                failedCount += 1;

                  console.error(

                    '❌ Error guardando parciales de ' +

                    participant.fullname +

                    ':',

                    error.message
                  );
                }
              }
            )
          );


          console.log(

            `📦 Lote de parciales ` +

            `${index / batchSize + 1} procesado ` +

            `(${batch.length} atletas)`
          );
        }


        console.log(
          '🏁 Finalizado guardado de todos los resultados parciales'
        );


        return `Parciales: ${savedCount} guardados, ${failedCount} errores.`;
      }




      /*
       * ===================================================
       * LIMPIAR RESULTADOS ANTERIORES
       * ===================================================
       */

      try {

        const firstParticipant =
          data[
            0
          ];


        if (
          !firstParticipant

          ||

          !firstParticipant.distanceID
        ) {

          throw new Error(
            'No se encontró distanceID para limpiar los resultados.'
          );
        }


        if (
          this.props.competition ===
            PedestrismoBackup
        ) {

          console.log(
            '🧹 Limpiando resultados de backup...'
          );


          await axios.post(

            (API_BASE_URL + '/races/distance/')

            +

            firstParticipant.distanceID

            +

            '/clean-partial-results-backup'
          );

        } else {

          console.log(
            '🧹 Limpiando resultados anteriores...'
          );


          await axios.post(

            (API_BASE_URL + '/races/distance/')

            +

            firstParticipant.distanceID

            +

            '/clean-partial-results'
          );
        }


        console.log(
          '✔ Resultados limpios correctamente'
        );

      } catch (
        error
      ) {
        warnings += ' No se pudieron limpiar los resultados anteriores.';

        console.error(
          '❌ Error al limpiar resultados:',
          error.message
        );
      }


      /*
       * ===================================================
       * SUBIR RESULTADOS
       * ===================================================
       */

      const batchSize =
        10;


      for (
        let index = 0;

        index < data.length;

        index += batchSize
      ) {

        const batch =
          data.slice(
            index,
            index +
              batchSize
          );


        await Promise.all(
          batch.map(
            async (participant) => {

              try {

                // Use the numeric net time; the table's display format has less precision.
                const total = serializeResultDuration(this.getNetRegisteredTime(participant));

                const rhythm =
                  participant.rhythm

                    ? `${participant.rhythm}.0`

                    : '';


                let response;


                if (
                  this.props.competition ===
                    PedestrismoBackup
                ) {

                  const payload = {

                    uploaded_time:
                      total
                  };


                  response =
                    await axios.post(

                      (API_BASE_URL + '/user/')

                      +

                      participant.id

                      +

                      '/distance/'

                      +

                      participant.distanceID

                      +

                      '/save-results-backup',

                      payload
                    );

                } else {

                  const payload = {

                    total,

                    rhythm,

                    bib:
                      participant.number
                  };


                  response =
                    await axios.post(

                      (API_BASE_URL + '/user/')

                      +

                      participant.id

                      +

                      '/distance/'

                      +

                      participant.distanceID

                      +

                      '/save-results',

                      payload
                    );
                }


                if (
                  response.status ===
                    200
                ) {
                  savedCount += 1;

                  console.log(

                    `✅ ${participant.fullname} ` +

                    `(${participant.number}) guardado correctamente`
                  );

                } else {

                  failedCount += 1;
                  console.warn(

                    `⚠️ ${participant.fullname} respondió ` +

                    response.status
                  );
                }

              } catch (
                error
              ) {
                failedCount += 1;

                console.error(

                  `❌ Error guardando ${participant.fullname}:`,

                  error.message
                );
              }
            }
          )
        );


        console.log(

          `📦 Lote ${index / batchSize + 1} procesado ` +

          `(${batch.length} atletas)`
        );
      }


      console.log(
        '🏁 Finalizado guardado de todos los resultados'
      );

      /*
      * =========================================================
      * NOTIFICAR A EXPERTIME LIVE
      * =========================================================
      *
      * Los resultados ya quedaron guardados en la API.
      * Ahora avisamos al sistema Live para que publique
      * la actualización por WebSocket.
      */
      if (savedCount > 0) try {

        console.log(
          '📡 Notificando actualización a Expertime Live...'
        );


        await axios.post(
          (API_BASE_URL + '/races/') +
          eventID +
          '/live-results-updated'
        );


        console.log(
          '✅ Expertime Live notificado correctamente'
        );

      } catch (error) {
        warnings += ' No se pudo notificar a Live.';

        console.error(
          '⚠️ Los resultados se guardaron, pero no se pudo notificar a Live:',
          error.message
        );
      }

      return `Resultados: ${savedCount} guardados, ${failedCount} errores.` + warnings;
    } catch (
      globalError
    ) {

      console.error(
        '💥 Error general en handleClick:',
        globalError
      );
      throw globalError;
    }
  }


  /*
   * =======================================================
   * POSICION EN ARRAY
   * =======================================================
   */

  getPositionOf(
    number
  ) {

    const participantList =
      Array.isArray(
        this.props.participantList
      )
        ? this.props.participantList
        : [];


    return participantList.findIndex(
      (participant) => {

        return (

          participant.number

          ===

          number
        );
      }
    );
  }


  /*
   * =======================================================
   * EQUIPOS
   * =======================================================
   */

  expandComponent(
    row
  ) {

    return (

      <BSTable
        data={
          row.team
        }
      />
    );
  }


  isExpandableRow(
    row
  ) {

    return (

      Array.isArray(
        row.team
      )

      &&

      row.team.length > 1
    );
  }


  expandColumnComponent({
    isExpandableRow,
    isExpanded
  }) {

    let content =
      '';


    if (
      isExpandableRow
    ) {

      content =
        isExpanded
          ? '-'
          : '+';
    }


    return (

      <div>
        {
          content
        }
      </div>
    );
  }


  /*
   * =======================================================
   * EDICION MANUAL
   * =======================================================
   */

  onAfterSaveCell(
    row,
    cellName,
    cellValue
  ) {

    if (
      cellName ===
        Parcial1Field

      ||

      cellName ===
        Parcial2Field

      ||

      cellName ===
        Parcial3Field
    ) {

      const index =
        this.getPositionOf(
          row.number
        );


      if (
        index < 0
      ) {

        return;
      }


      const editedTime =
        String(
          cellValue
        ).split(
          ':'
        );


      if (
        editedTime.length < 3
      ) {

        console.warn(
          'El tiempo debe tener el formato HH:MM:SS'
        );


        return;
      }


      const seconds =

        Number(
          editedTime[
            0
          ]
        )

        *

        60

        *

        60

        +

        Number(
          editedTime[
            1
          ]
        )

        *

        60

        +

        Number(
          editedTime[
            2
          ]
        );


      if (
        Number.isNaN(
          seconds
        )
      ) {

        console.warn(
          'El tiempo ingresado no es válido.'
        );


        return;
      }


      let newTime =
        0;


      let originalTime =
        0;


      switch (
        cellName
      ) {

        case Parcial1Field: {

          const categoryOffsetMs =

            (
              this.props.competition ===
                Pedestrismo

              ||

              this.props.competition ===
                PedestrismoBackup
            )

              ? 0

              : this.getCategoryStartOffset(
                row
              )

                *

                60

                *

                1000;


          newTime =

            Math.floor(
              seconds *
              1000
            )

            +

            this.props.startedAt

            +

            categoryOffsetMs;


          originalTime =
            row.registeredTime1;


          break;
        }


        case Parcial2Field:

          newTime =

            Math.floor(
              seconds *
              1000
            )

            +

            row.registeredTime1;


          originalTime =
            row.registeredTime2;


          break;


        case Parcial3Field:

          newTime =

            Math.floor(
              seconds *
              1000
            )

            +

            row.registeredTime2;


          originalTime =
            row.registeredTime3;


          break;


        default:

          return;
      }


      const deltaTime =

        newTime

        -

        originalTime;


      setTimeout(
        () => {

          this.props.editRegisterTime(
            deltaTime,
            newTime,
            index,
            cellName
          );

        },
        1
      );
    }
  }


  onBeforeSaveCell() {

    return true;
  }

    /*
   * =======================================================
   * BOTONES TABLA
   * =======================================================
   */

  renderButtonGroup(
    props,
    distanceType
  ) {

    return (

      <ButtonGroup
        className="my-custom-class"
      >

        {
          props.showSelectedOnlyBtn
        }

        {
          props.exportCSVBtn
        }

        <Button
          onClick={
            () => {

              this.handleClick(
                this.props.eventID,
                distanceType
              );
            }
          }
          bsStyle={this.props.competition === PedestrismoBackup ? 'danger' : 'primary'}
          className={this.props.competition === PedestrismoBackup ? 'btn-backup' : ''}
          disabled={this.state.uploading || this.state.copyingResult}
        >
          {this.state.uploading ? 'Subiendo…' : 'Subir Resultados'}
        </Button>

      </ButtonGroup>
    );
  }


  getPedestrianTableOptions(
    distanceType
  ) {

    const participantList =
      Array.isArray(
        this.props.participantList
      )
        ? this.props.participantList
        : [];


    const totalParticipants =
      participantList.length;


    return {

      exportCSVText:
        'CSV',

      noDataText:
        'Aún no hay resultados!',

      btnGroup:
        (props) => {

          return this.renderButtonGroup(
            props,
            distanceType
          );
        },

      mode:
        'click',

      sizePerPage:
        totalParticipants ||
        1,

      paginationSize:
        3,

      paginationPosition:
        'bottom',

      sizePerPageList: [

        {
          text:
            '3',
          value:
            3
        },

        {
          text:
            '5',
          value:
            5
        },

        {
          text:
            '10',
          value:
            10
        },

        {
          text:
            '25',
          value:
            25
        },

        {
          text:
            '50',
          value:
            50
        },

        {
          text:
            'Todos',
          value:
            totalParticipants ||
            1
        }
      ]
    };
  }


  /*
   * Opciones de la grilla única
   * para MTB / combinadas.
   */
  getCategoryStartTableOptions(
    totalParticipants
  ) {

    const total =
      Number(
        totalParticipants || 0
      );


    return {

      exportCSVText:
        'CSV',

      noDataText:
        'Aún no hay resultados!',

      mode:
        'click',

      sizePerPage:
        total ||
        1,

      paginationSize:
        3,

      paginationPosition:
        'bottom',

      sizePerPageList: [

        {
          text:
            '10',
          value:
            10
        },

        {
          text:
            '25',
          value:
            25
        },

        {
          text:
            '50',
          value:
            50
        },

        {
          text:
            'Todos',
          value:
            total ||
            1
        }
      ]
    };
  }


  renderCategoryResultsUploadButton() {

    return (

      <div
        style={{
          marginBottom:
            '15px',

          textAlign:
            'right'
        }}
      >

        <Button
          bsStyle={this.props.competition === PedestrismoBackup ? 'danger' : 'primary'}
          className={this.props.competition === PedestrismoBackup ? 'btn-backup' : ''}

          onClick={
            () => {

              this.handleClick(
                this.props.eventID,
                this.props.distance1Type
              );
            }
          }
        >
          Subir Resultados
        </Button>

      </div>
    );
  }


  /*
   * =======================================================
   * TABLA PEDESTRISMO
   * =======================================================
   */

  renderPedestrianDistanceTable(
    distanceConfig,
    orderedCategories
  ) {

    const distanceType =
      distanceConfig.type;


    return (

      <Row
        key={
          `pedestrian-distance-${distanceConfig.id}-${distanceType}`
        }
        className="show-grid Td-sombreado-p1"
      >

        <Col md={12}>

          <BootstrapTable
            data={
              this.formattedList(
                distanceType
              )
            }
            pagination
            multiColumnSort={2}
            cellEdit={
              this.state.cellEditProp
            }
            options={
              this.getPedestrianTableOptions(
                distanceType
              )
            }
            striped
            hover
            condensed
            exportCSV
          >

            <TableHeaderColumn
              row="0"
              colSpan="13"
            >
              <center>
                DISTANCIA {distanceType}K
              </center>
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="posGral"
              row="1"
              width="70"
              columnClassName="Td-sombreado-p2"
              dataSort
              dataAlign="center"
              export
            >
              # Gral
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="posCat"
              row="1"
              width="100"
              dataSort
              dataAlign="center"
              export
            >
              # Cat
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="posGender"
              row="1"
              width="100"
              dataSort
              dataAlign="center"
              export
            >
              # Sexo
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="number"
              row="1"
              width="100"
              filter={{
                type:
                  'TextFilter',

                delay:
                  1,

                selectText:
                  'Filtrar por '
              }}
              dataAlign="center"
              export
            >
              Dorsal
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="fullname"
              row="1"
              width="15%"
              filter={{
                type:
                  'TextFilter',

                delay:
                  1,

                selectText:
                  'Filtrar por '
              }}
              export
            >
              Atleta
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="gender"
              row="1"
              width="100"
              dataAlign="center"
              filterFormatted
              dataFormat={
                this.enumFormatter
              }
              formatExtraData={
                this.state.genderList
              }
              filter={{
                type:
                  'SelectFilter',

                options:
                  this.state.genderList,

                selectText:
                  '',

                condition:
                  'eq'
              }}
              export
            >
              Sexo
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="catName"
              row="1"
              dataAlign="center"
              filterFormatted
              dataSort
              dataFormat={
                this.enumFormatter
              }
              formatExtraData={
                orderedCategories
              }
              filter={{
                type:
                  'SelectFilter',

                options:
                  orderedCategories,

                selectText:
                  '',

                condition:
                  'eq'
              }}
              export
            >
              Categoría
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="distance"
              row="1"
              hidden
            >
              Distancia
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="club"
              row="1"
              dataAlign="center"
              dataSort
              export
            >
              Club
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="city"
              row="1"
              dataAlign="center"
              export
            >
              Ciudad
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="id"
              row="1"
              isKey
              hidden
              export
            >
              ID
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="status"
              row="1"
              width="90"
              dataSort
              dataAlign="center"
              export
            >
              Estado
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="rhythm"
              row="1"
              dataAlign="center"
              export
            >
              Ritmo [Min/Km]
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="registeredTime1"
              row="1"
              hidden
            >
              Tiempo Oficial
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="formattedTime1"
              row="1"
              columnClassName="Td-sombreado-p2"
              dataSort
              dataAlign="center"
              export
            >
              Tiempo Oficial
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="totalTime"
              row="1"
              hidden
              export={false}
            >
              T.Total
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="button"
              row="1"
              width="60"
              dataAlign="center"
              dataFormat={
                this.buttonFormatter
              }
              export={false}
            >
              SMS
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="distanceID"
              row="1"
              hidden
              export
            >
              Distance ID
            </TableHeaderColumn>

          </BootstrapTable>

        </Col>

      </Row>
    );
  }


  /*
   * =======================================================
   * TABLA GENERAL RURAL BIKE / MTB
   * =======================================================
   *
   * Una sola grilla:
   *
   * - Largada
   * - Llegada
   * - Tiempo Neto
   */

  renderRuralBikeTable() {

    const data =
      this.ruralBikeFormattedList();


    return (

      <Row>

        <Col md={12}>

          <BootstrapTable
            key="rural-bike-results"
            data={data}
            pagination
            multiColumnSort={2}
            options={
              this.getCategoryStartTableOptions(
                data.length
              )
            }
            cellEdit={
              this.state.cellEditProp
            }
            striped
            hover
            condensed
            exportCSV
          >

            <TableHeaderColumn
              dataField="id"
              isKey
              hidden
            >
              ID
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="posCat"
              width="70"
              dataSort
              dataAlign="center"
              export
            >
              # Cat
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="number"
              width="80"
              filter={{
                type:
                  'TextFilter',

                delay:
                  1,

                selectText:
                  'Filtrar por '
              }}
              dataAlign="center"
              export
            >
              # Placa
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="fullname"
              width="18%"
              filter={{
                type:
                  'TextFilter',

                delay:
                  1,

                selectText:
                  'Filtrar por '
              }}
              export
            >
              Ciclista
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="catCod"
              width="14%"
              dataAlign="center"
              dataSort
              export
            >
              Categoría
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="catCod"
              hidden
              export
            >
              Cat
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="club"
              width="14%"
              dataSort
              dataAlign="center"
              export
            >
              Club
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="city"
              width="14%"
              dataAlign="center"
              export
            >
              Ciudad
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="status"
              width="70"
              dataAlign="center"
              dataSort
              export
            >
              Estado
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="startOffset"
              hidden
              export={false}
            >
              Offset
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="startLabel"
              width="115"
              dataAlign="center"
              dataSort
              export
            >
              Largada
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="arrivalTime"
              hidden
              export={false}
            >
              Llegada Ms
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="formattedArrivalTime"
              width="120"
              dataAlign="center"
              export
            >
              Llegada
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="netTime"
              hidden
              export={false}
            >
              Tiempo Neto Ms
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="formattedTime1"
              width="120"
              columnClassName="Td-sombreado"
              dataSort
              dataAlign="center"
              export
            >
              Tiempo Neto
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="button"
              width="60"
              dataAlign="center"
              dataFormat={
                this.buttonFormatter
              }
              export={false}
            >
              SMS
            </TableHeaderColumn>

          </BootstrapTable>

        </Col>

      </Row>
    );
  }

    /*
   * =======================================================
   * TABLA GENERAL COMBINADA SIMPLE
   * =======================================================
   */

  renderCombinadaSimpleTable() {

    const data =
      this.combinadaFormattedList();


    return (

      <Row
        className="show-grid Td-sombreado-p1"
      >

        <Col md={12}>

          <BootstrapTable
            key="combined-simple-results"
            expandColumnOptions={{

              expandColumnVisible:
                true,

              expandColumnComponent:
                this.expandColumnComponent,

              columnWidth:
                20
            }}
            expandableRow={
              this.isExpandableRow
            }
            expandComponent={
              this.expandComponent
            }
            data={data}
            pagination
            multiColumnSort={2}
            cellEdit={
              this.state.cellEditProp
            }
            options={
              this.getCategoryStartTableOptions(
                data.length
              )
            }
            striped
            hover
            condensed
            exportCSV
          >

            <TableHeaderColumn
              dataField="id"
              isKey
              hidden
            >
              ID
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="posCat"
              width="70"
              dataSort
              dataAlign="center"
              export
            >
              # Cat
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="number"
              width="80"
              dataAlign="center"
              export
            >
              # Dorsal
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="fullname"
              width="18%"
              filter={{
                type:
                  'TextFilter',

                delay:
                  1,

                selectText:
                  'Filtrar por '
              }}
              export
            >
              Atleta
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="gender"
              width="70"
              dataAlign="center"
              filterFormatted
              dataFormat={
                this.enumFormatter
              }
              formatExtraData={
                this.state.genderList
              }
              filter={{
                type:
                  'SelectFilter',

                options:
                  this.state.genderList,

                selectText:
                  '',

                condition:
                  'eq'
              }}
              export
            >
              Sexo
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="distanceName"
              width="100"
              dataAlign="center"
              export
            >
              Distancia
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="catName"
              width="14%"
              dataAlign="center"
              dataSort
              export
            >
              Categoría
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="catCod"
              hidden
              export
            >
              Cat
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="city"
              width="14%"
              dataAlign="center"
              filter={{
                type:
                  'TextFilter',

                delay:
                  1,

                selectText:
                  'Filtrar por '
              }}
              export
            >
              Ciudad
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="status"
              width="70"
              dataAlign="center"
              dataSort
              export
            >
              Estado
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="startLabel"
              width="115"
              dataAlign="center"
              dataSort
              export
            >
              Largada
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="arrivalTime"
              hidden
              export={false}
            >
              Llegada Ms
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="formattedArrivalTime"
              width="120"
              dataAlign="center"
              export
            >
              Llegada
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="netTime"
              hidden
              export={false}
            >
              Tiempo Neto Ms
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="formattedTime1"
              width="120"
              columnClassName="Td-sombreado"
              dataSort
              dataAlign="center"
              export
            >
              Tiempo Neto
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="buttonIncrement"
              width="60"
              dataAlign="center"
              dataFormat={
                this.actionIncTimeButton
              }
              export={false}
            >
              + min
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="buttonDecrement"
              width="60"
              dataAlign="center"
              dataFormat={
                this.actionDecTimeButton
              }
              export={false}
            >
              - min
            </TableHeaderColumn>

          </BootstrapTable>

        </Col>

      </Row>
    );
  }


  /*
   * =======================================================
   * TABLA GENERAL COMBINADA SPRINT
   * =======================================================
   */

  renderCombinadaSprintTable() {

    const data =
      this.combinadaSprintFormattedList();


    return (

      <Row>

        <Col md={12}>

          <BootstrapTable
            key="combined-sprint-results"
            expandColumnOptions={{

              expandColumnVisible:
                true,

              expandColumnComponent:
                this.expandColumnComponent,

              columnWidth:
                20
            }}
            expandableRow={
              this.isExpandableRow
            }
            expandComponent={
              this.expandComponent
            }
            data={data}
            pagination
            multiColumnSort={2}
            cellEdit={
              this.state.cellEditProp
            }
            options={
              this.getCategoryStartTableOptions(
                data.length
              )
            }
            striped
            hover
            condensed
            exportCSV
          >

            <TableHeaderColumn
              dataField="id"
              isKey
              hidden
            >
              ID
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="number"
              width="80"
              filter={{
                type:
                  'TextFilter',

                delay:
                  1,

                selectText:
                  'Filtrar por '
              }}
              dataAlign="center"
              export
            >
              # Dorsal
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="fullname"
              width="16%"
              filter={{
                type:
                  'TextFilter',

                delay:
                  1,

                selectText:
                  'Filtrar por '
              }}
              export
            >
              Atleta
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="gender"
              width="70"
              dataAlign="center"
              filterFormatted
              dataFormat={
                this.enumFormatter
              }
              formatExtraData={
                this.state.genderList
              }
              filter={{
                type:
                  'SelectFilter',

                options:
                  this.state.genderList,

                selectText:
                  '',

                condition:
                  'eq'
              }}
              export
            >
              Sexo
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="catName"
              width="14%"
              dataAlign="center"
              dataSort
              export
            >
              Categoría
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="catCod"
              hidden
              export
            >
              Cat
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="city"
              width="14%"
              dataAlign="center"
              filter={{
                type:
                  'TextFilter',

                delay:
                  1,

                selectText:
                  'Filtrar por '
              }}
              export
            >
              Ciudad
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="status"
              width="70"
              dataAlign="center"
              dataSort
              export
            >
              Estado
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="startLabel"
              width="115"
              dataAlign="center"
              dataSort
              export
            >
              Largada
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="formattedArrivalTime"
              width="110"
              dataAlign="center"
              export
            >
              Llegada P1
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="formattedTime1"
              width="110"
              columnClassName="Td-sombreado-p2"
              dataSort
              dataAlign="center"
              export
            >
              Parcial 1 Neto
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="formattedTime2"
              width="110"
              columnClassName="Td-sombreado-p3"
              dataSort
              dataAlign="center"
              export
            >
              Parcial 2
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="totalTime"
              hidden
              export={false}
            >
              Tiempo Neto Ms
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="formattedTotalTime"
              width="120"
              columnClassName="Td-sombreado"
              dataSort
              dataAlign="center"
              export
            >
              Tiempo Neto
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="buttonIncrement"
              width="60"
              dataAlign="center"
              dataFormat={
                this.actionIncTimeButton
              }
              export={false}
            >
              + min
            </TableHeaderColumn>


            <TableHeaderColumn
              dataField="buttonDecrement"
              width="60"
              dataAlign="center"
              dataFormat={
                this.actionDecTimeButton
              }
              export={false}
            >
              - min
            </TableHeaderColumn>

          </BootstrapTable>

        </Col>

      </Row>
    );
  }


  /*
   * =======================================================
   * TITULO
   * =======================================================
   */

  renderTitle() {

    return (

      <Row
        className="show-grid"
      >

        <Col md={12}>

          <PageHeader>

            {
              this.props.alertOn ===
              true

                ? (

                  <Alert
                    variant={
                      this.props.alertVnt
                    }
                  >

                    <Alert.Heading>
                      {
                        this.props.alertMsg
                      }
                    </Alert.Heading>

                  </Alert>
                )

                : null
            }


            <center>

              CLASIFICACI&Oacute;N {
                this.props.name
              }

            </center>

          </PageHeader>

        </Col>

      </Row>
    );
  }


  /*
   * =======================================================
   * RENDER
   * =======================================================
   */

  render() {
    const pedestrian = this.props.competition === Pedestrismo || this.props.competition === PedestrismoBackup;
    const distances = pedestrian
      ? this.getConfiguredDistances().map(distance => ({ ...distance, label: distance.type + 'K' }))
      : [{ id: 'general', type: this.props.distance1Type, label: 'General' }];
    return <div>
      <FloatingRacePanel distances={distances} eventID={this.props.eventID}
        uploading={this.state.uploading} status={this.state.uploadStatus}
        log={this.state.uploadLog} onUpload={this.handleClick}
        copyingResult={this.state.copyingResult} onCopyingChange={copying => {
          this.copyInProgress = copying;
          this.setState({ copyingResult: copying });
        }} />
      {this.renderResults()}
    </div>;
  }

  renderResults() {

    const title =
      this.renderTitle();


    const catStats =
      Array.isArray(
        this.props.catStats
      )
        ? this.props.catStats
        : [];


    const categories =
      catStats
        .slice()
        .sort(
          (
            category1,
            category2
          ) => {

            const order1 =
              parseInt(
                category1.order,
                10
              )
              ||
              0;


            const order2 =
              parseInt(
                category2.order,
                10
              )
              ||
              0;


            return (
              order1 -
              order2
            );
          }
        );


    const orderedCategories =
      {};


    categories.forEach(
      (category) => {

        if (
          category &&
          category.label
        ) {

          orderedCategories[
            category.label
          ] =
            category.label;
        }
      }
    );


    /*
     * ===================================================
     * PEDESTRISMO
     * ===================================================
     */
    if (
      this.props.competition ===
        Pedestrismo

      ||

      this.props.competition ===
        PedestrismoBackup
    ) {

      const configuredDistances =
        this.getConfiguredDistances();


      return (

        <div>

          <Grid fluid>

            {
              title
            }


            {
              configuredDistances.length > 0

                ? configuredDistances.map(
                  (
                    distanceConfig
                  ) => {

                    return this.renderPedestrianDistanceTable(
                      distanceConfig,
                      orderedCategories
                    );
                  }
                )

                : (

                  <Row>

                    <Col md={12}>

                      <Alert
                        bsStyle="warning"
                      >
                        No hay distancias configuradas.
                      </Alert>

                    </Col>

                  </Row>
                )
            }

          </Grid>

        </div>
      );
    }


    /*
     * ===================================================
     * RURAL BIKE / MTB
     * ===================================================
     */
    if (
      this.props.competition ===
        RuralBike
    ) {

      return (

        <div>

          <Grid fluid>

            {
              title
            }


            {
              this.renderCategoryResultsUploadButton()
            }


            {
              this.renderRuralBikeTable()
            }

          </Grid>

        </div>
      );
    }


    /*
     * ===================================================
     * COMBINADA SIMPLE
     * ===================================================
     */
    if (
      this.props.competition ===
        CombinadaSimple
    ) {

      return (

        <div>

          <Grid fluid>

            {
              title
            }


            {
              this.renderCategoryResultsUploadButton()
            }


            {
              this.renderCombinadaSimpleTable()
            }

          </Grid>

        </div>
      );
    }


    /*
     * ===================================================
     * COMBINADA SPRINT
     * ===================================================
     */
    if (
      this.props.competition ===
        CombinadaSprint
    ) {

      return (

        <div>

          <Grid fluid>

            {
              title
            }


            {
              this.renderCategoryResultsUploadButton()
            }


            {
              this.renderCombinadaSprintTable()
            }

          </Grid>

        </div>
      );
    }


    return <div />;
  }
}


/*
 * =========================================================
 * REDUX
 * =========================================================
 */

function mapDispatchToProps(
  dispatch
) {

  return bindActionCreators(
    {

      editRegisterTime,

      incTime,

      decTime
    },

    dispatch
  );
}


function mapStateToProps(
  state
) {

  const reducerRegisterTime =
    state.reducerRegisterTime
    ||
    {};


  const reducerTimer =
    state.reducerTimer
    ||
    {};


  const reducerRegisterInfo =
    state.reducerRegisterInfo
    ||
    {};


  const participantList =
    Array.isArray(
      reducerRegisterTime.participantList
    )
      ? reducerRegisterTime.participantList
      : [];


  const catStats =
    Array.isArray(
      reducerRegisterTime.catStats
    )
      ? reducerRegisterTime.catStats
      : [];


  const {
    startedAt,
    stoppedAt
  } =
    reducerTimer;


  const {

    eventID,

    name,

    date,

    place,

    distance1Type,

    distance1Value,

    distance2Type,

    distance2Value,

    distance3Type,

    distance3Value,

    categoryStartOffsets,

    sendSMS,

    competition

  } =
    reducerRegisterInfo;


  return {

    eventID,

    participantList,

    catStats,

    startedAt,

    stoppedAt,

    distance1Type,

    distance1Value,

    distance2Type,

    distance2Value,

    distance3Type,

    distance3Value,

    categoryStartOffsets:
      Array.isArray(
        categoryStartOffsets
      )
        ? categoryStartOffsets
        : [],

    name,

    date,

    place,

    sendSMS,

    competition
  };
}


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  ResultsTable
);


/*
 * =========================================================
 * TABLA DE INTEGRANTES
 * =========================================================
 */

class BSTable extends React.Component {

  render() {

    const data =
      Array.isArray(
        this.props.data
      )
        ? this.props.data
        : [];


    if (
      data.length > 0
    ) {

      return (

        <BootstrapTable
          key="expanded-team-table"
          data={
            data
          }
        >

          <TableHeaderColumn
            dataField="id"
            isKey
            hidden
          >
            ID
          </TableHeaderColumn>


          <TableHeaderColumn
            dataField="last"
            export
          >
            Apellido
          </TableHeaderColumn>


          <TableHeaderColumn
            dataField="first"
            export
          >
            Nombre
          </TableHeaderColumn>


          <TableHeaderColumn
            dataField="gender"
            width="70"
            dataAlign="center"
            export
          >
            Sexo
          </TableHeaderColumn>


          <TableHeaderColumn
            dataField="distance"
            width="100"
            dataAlign="center"
            export
          >
            Distancia
          </TableHeaderColumn>


          <TableHeaderColumn
            dataField="city"
            dataAlign="center"
            export
          >
            Ciudad
          </TableHeaderColumn>

        </BootstrapTable>
      );
    }


    return (

      <p>
        Sin integrantes
      </p>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/results-table.js